import { render } from "./CookiePolicy.vue?vue&type=template&id=1eea9b64&scoped=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import "./CookiePolicy.vue?vue&type=style&index=0&id=1eea9b64&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eea9b64"]])

export default __exports__